module.exports = __webpack_public_path__ + "img/banner3.7b55bd56.jpg";